<span *ngIf="!isNaN; else none" class="price-tag" [class.text-danger]="value < 0">
  <span *ngIf="unit" class="currency">{{ unit }}</span>
  {{ integer|number:'1.0':currentLang }}<span class="cents">{{ decimals }}</span>
</span>
<ng-template #none>
  <span class="text-muted no-select">&#8212;</span>
</ng-template>